<template>
    <v-container fluid class="pt-0">
        <v-row>
            <v-col cols="12">
                <v-row>
                    <v-col>
                        <h2>
                            {{ $t('editUserInformation.title') }}
                        </h2>
                    </v-col>
                </v-row>
                <v-row class="justify-center">
                    <v-col cols="12" md="6">
                        <profile-image-form />
                        <profile-information-form />
                    </v-col>
                    <v-col cols="12" md="6">
                        <profile-new-password-form />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'profileView',

    components: {
        ProfileImageForm: () => import('@/components/ProfileImageForm'),
        ProfileInformationForm: () =>
            import('@/components/ProfileInformationForm'),
        ProfileNewPasswordForm: () =>
            import('@/components/ProfileNewPasswordForm')
    }
};
</script>
